import React, { useEffect, useState } from 'react';
import "../../Assets/Css/Designation.scss";
import Listicon from "../../Assets/Images/Designation/listIcon";
import DesignationIcon from "../../Assets/Images/Designation/DesignationIcon";
import Table from '../../Components/Table';
import { useLocation, useNavigate } from 'react-router-dom';
import { addDesignation, getDesignations, updateDesignation } from '../../Services/Designation/action';
import { connect } from 'react-redux';
import { deleteRecord } from '../../Services/Delete/action';
import AddDesignationModal from '../../Components/AddDesignationModal';
import { Tree, getBackendOptions, MultiBackend } from "@minoru/react-dnd-treeview";
import { Tree as OrganizedTree, TreeNode as OrgNode } from "react-organizational-chart";
import { FaUserTie } from "react-icons/fa";
import { DndProvider } from 'react-dnd';
import { FaArrowRightLong } from 'react-icons/fa6';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper';
import { getDepartments } from "../../Services/Department/action";
import Skeleton from 'react-loading-skeleton';

const ChartNode = ({ label, departments = [] }) => (
    <div style={{
        border: "1px solid #ccc",
        padding: 8,
        borderRadius: 4,
        minWidth: '200px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa'
    }}>
        <div style={{
            fontWeight: 'bold',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <FaUserTie style={{ marginRight: '5px' }} /> {label}
        </div>
        {departments.length > 0 && (
            <div style={{
                fontSize: '12px',
                color: '#666',
                borderTop: '1px solid #eee',
                paddingTop: '5px'
            }}>
                {departments.map((department, index) => (
                    <div key={index} style={{ margin: '2px 0' }}>
                        {department}
                    </div>
                ))}
            </div>
        )}
    </div>
);

const Designation = (props) => {
    const [activeButton, setActiveButton] = useState("");
    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [treeData, setTreeData] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Designation,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Designation,
        Featur_Name: FeaturesList.Delete,
    });

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Designation,
        Featur_Name: FeaturesList.Update,
    });

    const navigate = useNavigate()
    const location = useLocation();
    const data = location?.state?.data?.allData;

    useEffect(() => {
        if (location.pathname == "/designation/chart") {
            const path = location.pathname.slice(13);
            setActiveButton(path)
        } else {
            const path = location.pathname.slice(1);
            setActiveButton(path)
        }
    }, []);

    const handleClick = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const header = [
        { field: "Name" },
        { field: "Department" },
        { field: "Parent Designation" },
        { field: "Action" },
    ];

    const fetchData = async () => {
        try {
            await props?.getDesignationList();
            await props.getDepartmentList();
        } catch (error) {
            console.error("Error fetching designations list:", error);
        }
    };

    const sortDesignationHierarchy = (designations) => {
        const nameToDesignation = new Map();
        const parentToChildren = new Map();
        const referencedParents = new Set();

        designations.forEach((d) => {
            nameToDesignation.set(d.name, d);
            if (d.parent_designation) {
                referencedParents.add(d.parent_designation);
                if (!parentToChildren.has(d.parent_designation)) {
                    parentToChildren.set(d.parent_designation, []);
                }
                parentToChildren.get(d.parent_designation).push(d);
            }
        });

        const visited = new Set();
        const result = [];

        const dfs = (designationName) => {
            const designation = nameToDesignation.get(designationName);
            if (!designation || visited.has(designation.id)) return;
            visited.add(designation.id);
            result.push(designation);

            const children = parentToChildren.get(designationName) || [];

            children
                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                .forEach(child => {
                    if (!visited.has(child.id)) {
                        visited.add(child.id);
                        result.push(child);
                    }
                });
        };

        referencedParents.forEach(parentName => dfs(parentName));

        designations.forEach(d => {
            if (!visited.has(d.id)) {
                result.push(d);
            }
        });

        return result;
    };

    const createTreeData = (designations) => {
        if (!designations || designations.length === 0) {
            console.log("No designations data available");
            return [];
        }



        const nameToIdMap = {};
        designations.forEach((designation) => {
            nameToIdMap[designation.name] = designation.id;
        });

        const treeNodes = designations.map((designation) => {
            const parentId = designation.parent_designation
                ? nameToIdMap[designation.parent_designation] || 0
                : 0;

            const associatedDepartments = props?.department?.filter(dept =>
                dept.designations?.some(d => d.name === designation.name || d.id === designation.id)
            ).map(dept => dept.name) || [];

            return {
                id: designation.id,
                parent: parentId,
                droppable: true,
                text: designation.name,
                departments: associatedDepartments
            };
        });

        return treeNodes;
    };

    useEffect(() => {
        fetchData();
    }, [location.search])

    useEffect(() => {
        const ordered = sortDesignationHierarchy(props?.designation);
        const nameToIdMap = {};

        props?.designation?.forEach((d) => {
            nameToIdMap[d.name] = d.id;
        });

        const tableData = props?.designation?.map((designation_detail) => {
            const departmentNames = props?.department?.filter(dept =>
                dept.designations?.some(d => d.name === designation_detail?.name || d.id === designation_detail?.id)
            ).map(dept => dept.name) || [];

            return {
                Name: {
                    value: designation_detail?.name,
                    type: 'text'
                },
                Department: {
                    value: departmentNames.length > 0 ? departmentNames.join(', ') : '-',
                    type: 'text'
                },
                "Parent Designation": {
                    value: designation_detail?.parent_designation || '-',
                    type: 'text'
                },
                Action: {
                    value: '/designation',
                    value2: '/designation/view',
                    value3: designation_detail?.id,
                    type: 'action'
                },
                allData: {
                    ...designation_detail
                }
            }
        });

        setInData(tableData);

        const treeNodes = createTreeData(props.designation);
        setTreeData(treeNodes);
    }, [props?.designation, props?.department]);

    const [isModalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        if (data) {
            setModalVisible(true);
        }
    }, [data]);

    const openModal = () => {
        setModalVisible(true);
    }

    const closeModal = async () => {
        setModalVisible(false);
        navigate(location.pathname, { replace: true, state: {} });
    };

    const applyFilters = ({ search }) => {
        const filtered = inData?.filter((designation) => {
            let matchesSearch = true;

            if (search) {
                matchesSearch = designation?.Name?.value?.toLowerCase().includes(search.toLowerCase());
            }

            return matchesSearch;
        });

        setFilteredData(filtered);
    };

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setSearchTerm(value);
        applyFilters({ search: value });
    };

    const handleClear = () => {
        setSearchTerm("");
        setFilteredData([]);
    };

    const renderOrgChart = (nodeId) => {
        const node = treeData.find((n) => n.id === nodeId);
        if (!node) return null;

        const children = treeData.filter((n) => n.parent === nodeId);
        const designationData = props?.designation?.find(designation => designation.id === nodeId);

        const departments = props?.department?.filter(dept =>
            dept.designations?.some(d => d.name === designationData?.name || d.id === designationData?.id)
        ).map(dept => dept.name) || [];

        return (
            <OrgNode label={<ChartNode label={node.text} departments={departments} />} key={node.id}>
                {children.map((child) => renderOrgChart(child.id))}
            </OrgNode>
        );
    };

    useEffect(() => {
        const filtered = inData?.filter((designation) => {
            let matchesSearch = true;
            let matchesDepartment = true;

            if (searchTerm) {
                matchesSearch = designation?.Name?.value?.toLowerCase().includes(searchTerm.toLowerCase());
            }

            if (selectedDepartment) {
                matchesDepartment = designation?.Department?.value === selectedDepartment.value;
            }

            return matchesSearch && matchesDepartment;
        });

        setFilteredData(filtered);
    }, [inData, searchTerm, selectedDepartment]);



    return (
        <div className='designation-container'>
            <div className="page-title">
                <h4>
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width={200} height={40} />
                        ) : (
                            "Designation"
                        )
                    }
                </h4>
                <div className='edit-btn'>
                    {
                        props.loading ? (
                            <Skeleton className="badge rounded-pill" width={100} height={40} />
                        ) : (
                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Designation}
                                Featur_Name={FeaturesList.Create}>

                                <button
                                    type="submit"
                                    className="custom-btn"
                                    disabled={props?.loading}
                                    onClick={openModal}
                                >
                                    Add Designation
                                </button>
                            </RoleWiseFeatureWrapper>
                        )
                    }
                </div>
            </div>

            <div>
                {
                    props.loading ? (
                        <Skeleton className="rounded-2" width="100%" height={40} />
                    ) : (
                        <div className='designation-filter-part'>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="input-css"
                                    name='search'
                                    placeholder='Search..'
                                    value={searchTerm || ""}
                                    onChange={searchFiled}
                                />
                            </div>
                            <div className='edit-btn'>
                                {searchTerm && (
                                    <button
                                        type="submit"
                                        className='custom-btn'
                                        onClick={handleClear}>
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>
                    )
                }
            </div>

            <div className='designation-action-button'>
                <div className="edit-btn">
                    {/* Export buttons can be added here */}
                </div>

                {
                    props.loading ? (
                        <Skeleton className="rounded-2" width={50} height={40} />
                    ) : (
                        <div className="navigation_btn">
                            <button
                                className={`btn1 ${activeButton === "designation" ? "active" : ""}`}
                                onClick={() => handleClick("designation", "/designation")}
                            >
                                <Listicon color={activeButton === "designation" ? "white" : "black"} bgColor={activeButton === "designation" ? "black" : "white"} />
                            </button>
                            <button
                                className={`btn1 ${activeButton === "chart" ? "active" : ""}`}
                                onClick={() => handleClick("chart", "/designation/chart")}
                            >
                                <DesignationIcon color={activeButton === "chart" ? "white" : "black"} bgColor={activeButton === "chart" ? "black" : "white"} />
                            </button>
                        </div>
                    )
                }
            </div>

            {location.pathname === "/designation" && (
                <div className="Designation-table-part">
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" count={5} width="100%" height={40} />
                        ) : (
                            <Table
                                loading={props?.loading}
                                header={header}
                                data={searchTerm ? filteredData : inData}
                                footer={true}
                                showIsView={canView}
                                showIsEdit={canEdit}
                                showIsDelete={canDelete}
                                count={inData?.length}
                                records={inData?.length}
                                deleteRecord={props?.deleteRecord}
                            />
                        )
                    }
                </div>
            )}

            {location.pathname === "/designation/chart" && (
                <div className='designation-chart-part'>
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width="100%" height="50vh" />
                        ) : (
                            <div className='designation-chart-grid'>
                                <div className="designation-chart-right-part designation-common-card">
                                    <p className='title-part'>Hierarchy View</p>

                                    {treeData.length > 0 ? (
                                        <div className='d-flex tree'>
                                            {treeData
                                                .filter((n) => n.parent === 0)
                                                .map((n) => (
                                                    <OrganizedTree
                                                        key={n.id}
                                                        treeLineColor="#777"
                                                        treeLineWidth="2px"
                                                        treeLineBorderRadius="10px"
                                                    >
                                                        {renderOrgChart(n.id)}
                                                    </OrganizedTree>
                                                ))}
                                        </div>
                                    ) : (
                                        <div style={{
                                            padding: '20px',
                                            textAlign: 'center',
                                            color: '#666',
                                            border: '1px dashed #ccc',
                                            borderRadius: '4px'
                                        }}>
                                            {props.loading ? 'Loading hierarchy...' : 'No hierarchy data available.'}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    }
                </div>
            )}

            <AddDesignationModal
                isModalVisible={isModalVisible}
                closeModal={closeModal}
                addDesignation={props?.addDesignation}
                loading={props?.loading}
                designationData={data}
                updateDesignation={props?.updateDesignation}
                departments={props?.department || []}
                designations={props?.designation || []}
            />
        </div>
    );
}

export const mapStateToProps = (state) => {
    return {
        loading: state.designationReducer.loading,
        designation: state.designationReducer.designation,
        department: state.departmentReducer.department,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getDesignationList: () => {
            dispatch(getDesignations());
        },
        getDepartmentList: () => {
            dispatch(getDepartments());
        },
        addDesignation: (data) => {
            dispatch(addDesignation(data));
        },
        updateDesignation: (id, data) => {
            dispatch(updateDesignation(id, data));
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue));
            await dispatch(getDesignations());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Designation);